import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import {
  Avatar
} from 'react-toolbox/lib/avatar'
import cardTheme from './themes/card-title-right-actions.css'

const CardTitleRightActions = ({ avatar, onAvatarClick, children, rightActions, className, subtitle, theme, title, ...other }) => {
  const classes = classnames(theme.cardTitle, className)

  return (
    <div className={classes} {...other}>
      <Avatar image={avatar} theme={theme} onClick={onAvatarClick} />
      <div className={theme.content}>
        {title && <h5 className={theme.title}>{title}</h5>}
        {children && typeof children === 'string' && (
          <h5 className={theme.title}>{children}</h5>
        )}
        {subtitle && <div className={theme.subtitle}>{subtitle}</div>}
        {children && typeof children !== 'string' && children}
      </div>
      <div className={theme.rightIcons}>
        {rightActions}
      </div>
    </div>
  );
};

CardTitleRightActions.propTypes = {
  avatar: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array,
  ]),
  className: PropTypes.string,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array,
  ]),
  theme: PropTypes.shape({
    large: PropTypes.string,
    title: PropTypes.string,
    small: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default themr('CardTitleRightActions', cardTheme)(CardTitleRightActions);



// WEBPACK FOOTER //
// ./src/web/components/card-title-right-actions.js